<template>
    <div>
        <input type="color" @click="focus" ref="color" v-model="color">
        <button type="button" @click="setcolor">Set</button>
    </div>
</template>

<script>

export default
{
    title: "Background color",
    description: "Font background color",
    icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata><g><g transform="translate(0.000000,430.000000) scale(0.100000,-0.100000)"><path d="M4201.63551.8c-32-20-85.9-65.9-117.8-99.8c-53.9-55.9-71.9-61.9-171.7-61.9c-325.5,0-938.6-71.9-1306-151.8c-794.8-173.7-1387.9-531.2-1587.6-956.5c-85.9-179.7-107.8-279.6-107.8-479.3c2-337.5,125.8-643,361.4-882.6L1405.9,784L822.8,194.9c-527.2-533.2-589.1-603.1-649-728.9c-53.9-117.8-65.9-167.7-71.9-321.5c-10-199.7,18-319.5,111.8-487.2c32-57.9,671-710.9,1749.3-1789.3c1557.6-1557.6,1709.4-1705.4,1829.2-1763.3c255.6-123.8,523.2-123.8,778.8,0c117.8,57.9,279.6,213.7,1837.2,1767.3c940.6,938.6,1719.4,1705.4,1731.3,1705.4c35.9,0,157.7-157.8,223.7-293.6c107.8-217.7,195.7-583.1,231.6-964.5c6-71.9,20-367.4,30-659c20-581.1,49.9-792.8,137.8-988.5c91.9-201.7,247.6-283.6,413.3-219.7c385.4,147.8,677,1238.1,720.9,2695.9c30,1030.4-155.8,1805.2-585.1,2450.2c-145.8,217.7-407.4,505.2-609.1,667C8077.7,1764.5,7193,2058.1,6228.5,2086l-329.5,10l-728.9,724.9c-401.4,399.4-748.9,734.9-772.8,746.9C4333.4,3599.7,4269.5,3593.7,4201.6,3551.8z M6254.5,1157.5l1931-1931L6324.4-2634.7c-1445.8-1443.8-1883.1-1871.1-1953-1901.1c-115.8-51.9-263.6-51.9-379.4,0c-69.9,30-463.3,413.4-1751.3,1701.4C1328-1919.8,565.2-1143,547.2-1105.1c-18,36-37.9,113.8-43.9,169.7c-20,197.7,10,237.7,661,888.7l585.1,585.1l197.7-93.9C2538.2,167,3364.9-10.7,4305.5-62.7l323.5-18l55.9-63.9c181.7-217.7,543.2-169.7,680.9,89.9c65.9,129.8,20,375.4-87.9,471.3c-165.7,145.8-411.4,139.8-569.1-14l-75.9-73.9l-245.6,14c-718.9,39.9-1399.8,157.8-1893.1,327.5c-193.7,65.9-419.4,163.8-419.4,181.7c0,14,2222.6,2238.6,2236.6,2238.6C4317.4,3090.5,5190.1,2221.8,6254.5,1157.5z M2646,2014.2l-936.6-936.6l-59.9,41.9c-87.9,65.9-225.7,259.6-275.6,389.4c-67.9,173.7-65.9,415.4,6,567.1c193.7,413.4,834.7,714.9,1793.2,842.7c115.8,16,253.6,27.9,309.5,30l99.8,2L2646,2014.2z M6971.4,1590.8c1563.6-317.5,2428.3-1316,2508.1-2895.6c35.9-726.9-47.9-1657.5-205.7-2260.5c-53.9-207.7-149.8-473.3-171.7-473.3c-32,0-75.9,523.2-77.9,908.6c0,427.3-59.9,898.6-151.8,1228.1c-65.9,235.6-223.7,545.2-345.5,680.9l-99.8,111.8l89.9,87.9c111.8,107.8,147.8,173.7,147.8,271.6c0,71.9-37.9,113.8-1172.2,1250.1L6318.4,1676.7l179.7-12C6597.9,1656.7,6809.6,1624.8,6971.4,1590.8z"/></g></g></svg>',
    data()
    {
        return {
            color: '#000000'
        }
    },
    created()
    {
        this.$nextTick(() =>
        {
            this.$refs.color.focus();;
        });        
    },
    methods:
    {
        focus()
        {
            this.$refs.color.focus();
        },
        setcolor(e)
        {
            this.$parent.closeDashboard();
            this.$emit("exec", "hiliteColor", this.color);
        }
    }
};

</script>